import wikiManagement from './wikiManagement'
import banner from'./banner'
import homePage from './homePage'
import promotionPage from './promotionPage'

export default {
  wikiManagement,
  banner,
  homePage,
  promotionPage
}